export const BOOKING_QUESTION_SAVE_CHANGES_TYPE = {
  APPLY_TO_NEW: 1,
  APPLY_TO_EXISTING_AND_NEW: 2,
};

export const BOOKING_QUESTION_SAVE_CHANGES_OPTIONS = [
  {
    label: "Only apply to new offerings",
    value: BOOKING_QUESTION_SAVE_CHANGES_TYPE.APPLY_TO_NEW,
  },
  {
    label: "Apply to all offerings (existing and new)",
    value: BOOKING_QUESTION_SAVE_CHANGES_TYPE.APPLY_TO_EXISTING_AND_NEW,
  },
];

export const MODAL_CONTENT = {
  NOTE: "You’re seeing this popup because some of the details you are about to update, are currently customised for certain offerings.",
  HEADER:
    "Would you like to apply these updates to all existing offerings as well, or just to new ones?",
};
